var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css, styled } from 'styled-components';
import { getDynamicToken } from "../../utils/getDynamicToken";
import { pxToRem } from "../../utils";
export default styled.hr.withConfig({
  displayName: "styled",
  componentId: "1_5_0__sc-1h2yba8-0"
})(["", "{", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme.cssPrefix;
}, function (_ref2) {
  var $marginBottom = _ref2.$marginBottom,
    $marginLeft = _ref2.$marginLeft,
    $marginRight = _ref2.$marginRight,
    $marginTop = _ref2.$marginTop,
    theme = _ref2.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      border: 0;\n      border-top: ", "rem solid ", ";\n      margin: ", "\n        ", "\n        ", "\n        ", ";\n    "])), pxToRem(1), theme.vars.hr_color, getDynamicToken(theme.vars, "spacing_".concat($marginTop)), getDynamicToken(theme.vars, "spacing_".concat($marginRight)), getDynamicToken(theme.vars, "spacing_".concat($marginBottom)), getDynamicToken(theme.vars, "spacing_".concat($marginLeft)));
});